export default __webpack_public_path__ + "static/media/tob.ecc2aabb.svg";